
seedWebApp.controller('ConfirmChangeModalController', ['$scope', '$uibModalInstance', 'TranslationService', 'info',
    function ConfirmChangeModalController($scope, $uibModalInstance, TranslationService, info) {

        $scope.translation = TranslationService.getActiveTranslation();
        //console.log('ConfirmChangeModalCtrl.order');
        //console.log(info);

        $scope.info = info;
        $scope.stages = info.Stages;
        $scope.errors = [];        
        $scope.issue = info.Issue;
        $scope.attachType = 'Document';

        //Desabilitar approvals fora de sequencia
        $scope.validateApprovals = function () {
            //console.log('Skip validate if is back');
            if ($scope.info.IsBack) {
                return true;
            }
            

            $scope.errors = [];
            var disableNext = false;
            var ap;
            var i;
            if ($scope.info.ToStageID == 'DISAPPROVED') {
                //console.log('DISAPPROVED', $scope.info.Approvals);

                var reprov = 0;
                //OBRIGATORIO UM REPROVADX
                if ($scope.info.Approvals.length > 0) {
                    for (i in $scope.info.Approvals) {
                        ap = $scope.info.Approvals[i];
                        if (ap.IsApproved != null && ap.IsApproved == false) {
                            reprov++;
                            //ap.isDisabled = disableNext;
                            //disableNext = true;
                        }
                    }
                    if (reprov <= 0) {
                        $scope.errors.push('Nenhuma rejeição encontrada');
                    }
                }
            }
            else {
                var missing = 0;
                //OBRIGATORIO TODES APROVADX
                for (i in $scope.info.Approvals) {
                    ap = $scope.info.Approvals[i];
                    if (!ap.IsApproved) {
                        missing++;
                        ap.isDisabled = disableNext;
                        disableNext = true;
                    }
                }
                if (missing == 1) {
                    $scope.errors.push('Falta ' + missing + ' aprovação');
                }
                else if (missing > 1) {
                    $scope.errors.push('Faltam ' + missing + ' aprovações');
                }
            }
            
            return $scope.errors.length <= 0;
        };

        
        $scope.validateApprovals();



        $scope.$on('approvalStatusChanged', function (event, eventArgs) {
            //console.log('approvalStatusChanged', eventArgs);
            $scope.validateApprovals();
        });

        $scope.ok = function () {
            if (!$scope.validateApprovals()) {
                return;
            }
            $uibModalInstance.close($scope.info);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };


    }]
);